var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { "offset-sm1": "", sm10: "" } },
            [
              _c("v-select", {
                staticClass: "mb-3 db-list",
                attrs: { items: _vm.dbList, label: "--Select Database--" },
                nativeOn: {
                  change: function($event) {
                    return _vm.onDbChange($event)
                  }
                },
                model: {
                  value: _vm.selectedDb,
                  callback: function($$v) {
                    _vm.selectedDb = $$v
                  },
                  expression: "selectedDb"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticStyle: { "max-height": "500px", overflow: "auto" },
          attrs: { row: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "" } },
            [
              _c("p", { staticClass: "align-text-center" }, [
                _vm._v("\n                Database Schema\n            ")
              ]),
              _vm._v(" "),
              _c(
                "v-expansion-panel",
                _vm._l(_vm.dbInfo.tables, function(table) {
                  return _c(
                    "v-expansion-panel-content",
                    {
                      key: table.name,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      contextmenu: function($event) {
                                        $event.preventDefault()
                                        return _vm.$refs.ctxMenu.open($event, {
                                          table: table.name
                                        })
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(table.name))]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel",
                        { staticClass: "ml-4" },
                        _vm._l(table.columns, function(column) {
                          return _c(
                            "v-expansion-panel-content",
                            {
                              key: table.name + column.name,
                              staticClass: "column-name",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function() {
                                      return [
                                        _c("div", [_vm._v(_vm._s(column.name))])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("div", { staticClass: "margin-left-50px" }, [
                                _c("div", [
                                  _vm._v(
                                    "Primary Key :\n                                    "
                                  ),
                                  _c("span", { staticClass: "column-schema" }, [
                                    _vm._v(_vm._s(column.primaryKey))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "Auto Increment :\n                                    "
                                  ),
                                  _c("span", { staticClass: "column-schema" }, [
                                    _vm._v(_vm._s(column.autoIncrement))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "Not Null:\n                                    "
                                  ),
                                  _c("span", { staticClass: "column-schema" }, [
                                    _vm._v(_vm._s(column.notNull))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "Data Type :\n                                    "
                                  ),
                                  _c("span", { staticClass: "column-schema" }, [
                                    _vm._v(_vm._s(column.dataType))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "Default :\n                                    "
                                  ),
                                  _c("span", { staticClass: "column-schema" }, [
                                    _vm._v(_vm._s(column.default))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "Unique :\n                                    "
                                  ),
                                  _c("span", { staticClass: "column-schema" }, [
                                    _vm._v(_vm._s(column.unique))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "Multi Entry :\n                                    "
                                  ),
                                  _c("span", { staticClass: "column-schema" }, [
                                    _vm._v(_vm._s(column.multiEntry))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "Enable Search :\n                                    "
                                  ),
                                  _c("span", { staticClass: "column-schema" }, [
                                    _vm._v(_vm._s(column.enableSearch))
                                  ])
                                ])
                              ])
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "context-menu",
            {
              ref: "ctxMenu",
              attrs: { id: "context-menu" },
              on: { "ctx-open": _vm.onCtxOpen, "ctx-cancel": _vm.onCtxOff }
            },
            [
              _c(
                "li",
                { staticClass: "ctx-item", on: { click: _vm.select100 } },
                [_vm._v("Select 100 Record")]
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "ctx-item", on: { click: _vm.countTotal } },
                [_vm._v("Count Total Record")]
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "ctx-item", on: { click: _vm.exportJson } },
                [_vm._v("Export As Json")]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }